/* eslint-disable no-console */
const prefix = '[analytics]';

export function pageview(code) {
  console.log(`${prefix} ${code} pageview triggered for ${window.location.pathname
  + window.location.search}`);
}

export function setExperiment(id, variation) {
  console.log(`${prefix} set experiment triggered for the experiment ${id} with variation ${variation}`);
}

export function event(data = {}) {
  console.log(`${prefix} Event for category ${data.category}, action ${data.action} triggered, label ${data.label} and value ${data.value}`);
}

export function eventSocial(data = {}) {
  console.log(`${prefix} Event for social ${data.socialNetwork}, action ${data.socialAction} triggered`);
}

export function exception(description = '', fatal = false) {
  console.log(
    `${prefix} ${
      fatal ? 'Fatal exception' : 'Exception'
    } with description ${description}`
  );
}
